/**
 * Coordinate Validators
 * Validates geographic coordinates and location objects
 */

/**
 * Validates if a coordinate is within valid latitude range
 * @param {number} lat - Latitude value
 * @returns {boolean} True if valid
 */
export function isValidLatitude(lat) {
  return typeof lat === 'number' && !isNaN(lat) && lat >= -90 && lat <= 90
}

/**
 * Validates if a coordinate is within valid longitude range
 * @param {number} lng - Longitude value
 * @returns {boolean} True if valid
 */
export function isValidLongitude(lng) {
  return typeof lng === 'number' && !isNaN(lng) && lng >= -180 && lng <= 180
}

/**
 * Validates if location object has valid coordinates
 * @param {Object} location - Location object with latitude/longitude
 * @returns {boolean} True if valid
 */
export function isValidLocation(location) {
  if (!location || typeof location !== 'object') return false
  
  const lat = location.latitude || location.lat
  const lng = location.longitude || location.lng
  
  return isValidLatitude(lat) && isValidLongitude(lng)
}

/**
 * Validates if radius is within acceptable range (1-100 km)
 * @param {number} radius - Radius in kilometers
 * @returns {boolean} True if valid
 */
export function isValidRadius(radius) {
  return typeof radius === 'number' && !isNaN(radius) && radius >= 1 && radius <= 100
}
